<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-wechat__wechatmauser">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.nickName" placeholder="昵称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.isBind" placeholder="是否绑定" clearable>
            <el-option :value="isBind.YES" :label="'是'"></el-option>
            <el-option :value="isBind.NO" :label="'否'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.isRelation" placeholder="关联微信公众号" clearable>
            <el-option :value="isRelation.YES" :label="'是'"></el-option>
            <el-option :value="isRelation.NO" :label="'否'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="headImgUrl" label="用户头像" header-align="center" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.headImgUrl" style="width: 50px">
          </template>
        </el-table-column>
        <el-table-column prop="nickName" label="昵称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userName" label="绑定用户" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isBind" label="是否绑定" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" type="success" v-if="scope.row.isBind===isBind.YES">已绑定</el-tag>
            <el-tag size="mini" type="danger" v-if="scope.row.isBind===isBind.NO">未绑定</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isRelation" label="关联微信公众号" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" type="success" v-if="scope.row.isRelation===isRelation.YES"> 已关联</el-tag>
            <el-tag size="mini" type="danger" v-if="scope.row.isRelation===isRelation.NO"> 未关联</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import { isRelation, isBind } from '@/constant'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/wechat/ma/user/page',
        getDataListIsPage: true
      },
      isBind,
      isRelation,
      dataForm: {
        nickName: '',
        isBind: '',
        isRelation: ''
      }
    }
  },
  watch: {
  }
}
</script>
